/**
 * ConfirmDialog.tsx - Confirmation dialog component
 * 
 * CHANGE HISTORY:
 * - 251025_1600 [pending] danielbeer: Initial creation
 * 
 * Confirmation dialog with customizable buttons
 */

import React from 'react';
import { Modal } from './Modal';
import { ConfirmConfig } from '../types';

export interface ConfirmDialogProps extends ConfirmConfig {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * ConfirmDialog - Confirmation dialog component
 * 
 * Features:
 * - Customizable confirm/cancel text
 * - Dangerous action styling
 * - Type-based theming (info, warning, error, success)
 */
export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'question',
  dangerous = false,
  onConfirm,
  onCancel
}) => {
  const footer = (
    <>
      <button className="btn btn-secondary" onClick={onCancel}>
        {cancelText}
      </button>
      <button 
        className={`btn ${dangerous ? 'btn-danger' : 'btn-primary'}`}
        onClick={onConfirm}
        autoFocus
      >
        {confirmText}
      </button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      type={type}
      size="small"
      footer={footer}
    >
      <p style={{ margin: 0, color: 'var(--text-primary)' }}>
        {message}
      </p>
    </Modal>
  );
};
